import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const QuickAccessWrapper = styled.div<{ $hide?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  height: 4rem;
  top: 1.8rem;
  right: 2.8rem;
  border-radius: 1rem;
  padding: 0.3rem;
  background: ${vars.colors.grey100};
  border: 1px solid ${vars.colors.grey80};
  z-index: ${vars.zIndex.drawer};

  ${(props) =>
    props.$hide &&
    css`
      display: none;
    `};

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    left: 0;
    width: 1px;
    height: 70%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: linear-gradient(
      180deg,
      rgba(44, 44, 46, 0.7) 0%,
      rgba(100, 177, 253, 0.7) 50.2%,
      rgba(44, 44, 46, 0.7) 100%
    );
  }
`;

export const QuickAccessButtonWrap = styled.div`
  position: relative;
`;

export const QuickAccessButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.4rem;
  width: 3.4rem;
  border: none;
  border-radius: 1rem;
  padding: 0;
  background: none;
  transition: background-color 0.12s;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: ${vars.colors.grey90};
  }

  svg {
    height: 2.4rem;
    width: 2.4rem;
    path {
      stroke: ${vars.colors.grey30};
    }
  }
`;

export const ShortcutLetter = styled.div`
  border: 1px solid ${vars.colors.grey80};
  background: ${vars.colors.grey90};
  color: ${vars.colors.grey30};
  border-radius: 0.4rem;
  font-family: Roobert, serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;
  position: absolute;
  top: calc(100% - 0.4rem);
  left: 50%;
  transform: translateX(-50%);
  width: 1.6rem;
  height: 1.9rem;
`;
